/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2017 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	GreenlightMessages.js
 *
 * Description:	Common Javascript functions for displaying message bubbles.
 *
 */

var g_oGreenlightMessages = {};

(function () {
    "use strict";

    function GreenlightMessage() {
        this.c_szUnauthorisedMessage = "";
    }

    /**
     * Displays a Success Bubble.
     * @param {string} szContent - Contents of bubble.
     * @param {number} [delay=0] - Duration in milliseconds before the bubble is displayed. Defaults to 0 (immediate display).
     */
    GreenlightMessage.prototype.displaySuccessBubble = function (szContent, delay) {
        delay = (typeof delay !== 'undefined') ? delay : 0; // Handle default value for delay
        setTimeout(function () {
            displayBubble("Success", "img/bubble_emblem-default24.png", szContent, false, true, false, "", "", false);
        }, delay);
    };

    /**
     * Displays an Error Bubble.
     * @param {string} szContent - Contents of bubble.
     */
    GreenlightMessage.prototype.displayErrorBubble = function (szContent) {
        displayBubble("Error", "img/Reject_Wht_24.png", szContent, false, true, false, "", "", false);
    };

    /**
     * Displays an Error Bubble.
     * @param {string} szContent - Contents of bubble.
     */
    GreenlightMessage.prototype.displayPermanentErrorBubble = function (szContent) {
        displayBubble("Error", "img/Reject_Wht_24.png", szContent, false, false, false, "", "", false);
    };

    /**
     * Displays a Warning Bubble.
     * @param {string} szContent - Contents of bubble.
     * @param {number} [delay=0] - Duration in milliseconds before the bubble is displayed. Defaults to 0 (immediate display).
     */
    GreenlightMessage.prototype.displayWarningBubble = function (szContent, delay) {
        delay = (typeof delay !== 'undefined') ? delay : 0; // Handle default value for delay
        setTimeout(function () {
            displayBubble("Warning", "img/bubble_dialog-warning24.png", szContent, false, true, false, "", "", false);
        }, delay);
    };

    /**
     * Displays an info Bubble.
     * @param {string} szContent - Contents of bubble.
     * @param {bool} bShowCollapseIcon - If a collapse icon should be shown.
     */
    GreenlightMessage.prototype.displayInfoBubble = function (szContent, bShowCollapseIcon) {
        displayBubble("Info", "img/bubble_dialog-info24.png", szContent, true, false, true, "", "", bShowCollapseIcon);
    };

    /**
     * Displays a Confirm Bubble
     * @param {string} szContent - Contents of bubble.
     * @param {string} confirmAction - The action of the confirm.
     * @param {string} cancelAction - The action of the cancel.
     */
    GreenlightMessage.prototype.displayConfirmBubble = function (szContent, confirmAction, cancelAction) {
        displayBubble("Confirm", "img/bubble_dialog-warning24.png", szContent, true, false, true, confirmAction, cancelAction, false);
    };

    /**
     * Shows the speech bubble in the required location.
     * @param {string} szType - Bubble type.
     * @param {string} szIcon - The icon to display within the bubble.
     * @param {string} szContent - Contents of bubble.
     * @param {bool} bDisplayTop - If the bubble should be displayed at the top.
     * @param {bool} bAutoClose - If the bubble should auto close.
     * @param {bool} bCloseOtherBubblesOfType - If other bubbles of the same type should be closed.
     * @param {string} szConfirmAction - The confirm action for confirm bubbles.
     * @param {string} szCancelAction - The cancel action for confirm bubbles.
     * @param {bool} bShowCollapseIcon - If the bubble should be collapsable.
     */
    var displayBubble = function (szType, szIcon, szContent, bDisplayTop, bAutoClose, bCloseOtherBubblesOfType, szConfirmAction, szCancelAction, bShowCollapseIcon) {

        // Set the width of the bubble.
        var iWidth = 300;

        // If we wish to close other bubbles of the same type.
        if (bCloseOtherBubblesOfType) {

            // Loop through each of the active bubbles.
            for (var i = 0; i < g_oActiveBubbles.length; i++) {

                // If this bubble is the same type.
                if (g_oActiveBubbles[i].type == szType) {

                    // Force close the bubble.
                    g_oGreenlightMessages.closeBubble(g_oActiveBubbles[i].id, true, true);
                }
            }
        }

        // Add the new bubble to the page.
        $("body").append(
            "<div id='divGLSpeech" + g_iActiveBubbleId + "' class='bubble" + szType + "' style='display: none;'>" +
            "<div id='divGLSpeech_Collapse_" + g_iActiveBubbleId + "' class='bubble__dismiss' onclick='g_oGreenlightMessages.toggleBubbleCollapse(" + g_iActiveBubbleId + ");' style='display: " + (bShowCollapseIcon ? "block" : "none") + ";'></div>" +
            "<table style='table-layout: fixed; width: 100%;'>" +
            "<tr>" +
            "<td align='center' valign='top' style='width: 30px;'><img src='" + szIcon + "' align='absmiddle' /></td>" +
            "<td id='tdSpeech_Content_" + g_iActiveBubbleId + "' align='left'><span id='spanSpeech_Content_" + g_iActiveBubbleId + "'>" + szContent + "</span></td>" +
            "<td id='tdSpeech_Confirm_" + g_iActiveBubbleId + "' " + (szType == "Confirm" ? "style='width: 60px;'" : "style='display: none;'") + " align='right' valign='top'>" +
            "<a id='tdSpeech_Confirm_" + g_iActiveBubbleId + "_Confirm' onclick='g_oGreenlightMessages.closeBubble(" + g_iActiveBubbleId + ", true, true);'><img src='img/bubble_yes24.png' align='absmiddle' /></a>" +
            "<a id='tdSpeech_Confirm_" + g_iActiveBubbleId + "_Reject' onclick='g_oGreenlightMessages.closeBubble(" + g_iActiveBubbleId + ", true, true);'><img src='img/Cancel-Close_wht_24.png' align='absmiddle' /></a>" +
            "</td>" +
            "</tr>" +
            "</table>" +
            "</div>"
        );

        // Set the confirm action if required.
        if (typeof (szConfirmAction) == "function") {
            $("#tdSpeech_Confirm_" + g_iActiveBubbleId + "_Confirm").click(function () { szConfirmAction(); });
        }

        // Set the cancel action if required.
        if (typeof (szCancelAction) == "function") {
            $("#tdSpeech_Confirm_" + g_iActiveBubbleId + "_Reject").click(function () { szCancelAction(); });
        }

        // Work out the height of the bubble (including any padding).
        var iBubbleHeight = ($("#divGLSpeech" + g_iActiveBubbleId).height() + parseInt($("#divGLSpeech" + g_iActiveBubbleId).css("padding-top")) + parseInt($("#divGLSpeech" + g_iActiveBubbleId).css("padding-bottom")));

        // Set the properties of the bubble.
        $("#divGLSpeech" + g_iActiveBubbleId).css("width", iWidth);
        $("#divGLSpeech" + g_iActiveBubbleId).css("right", -iWidth);
        $("#divGLSpeech" + g_iActiveBubbleId).css("z-index", 9999);

        // If we are displaying the bubble at the top.
        if (bDisplayTop) {

            // Move the bubble to the correct position.
            $("#divGLSpeech" + g_iActiveBubbleId).css("top", parseInt($("#divViewerCell").css("top").replace("px", "")) + (5 + ($("#divSepContainer").css("display") != "none" ? 40 : 0) + 10));	// Allow 5px for the loading bar, 40px for the slide out if shown, and 10 pixels of Margin.
        }
        // If we are displaying the bubble at the bottom.
        else {

            // Move the bubble to the correct position.
            $("#divGLSpeech" + g_iActiveBubbleId).css("top", $(window).height() - (iBubbleHeight + 10));	// Allow 10 pixels of Margin.
        }

        // Determine the position at which the bubble should be animated to.
        var iRightPos = parseInt($("#divGLSpeech" + g_iActiveBubbleId).css('right'));
        var iTargetRightPos = 10 + 8; // Allow 10 pixels of margin, and 8px for the viewer margin.

        // If the right slide out is shown, add the width of the slide out.
        if ($("#divSepContainer").css("display") != "none" && g_oSettings.g_oUserSettings.RightMenuCollapse == false) {
            iTargetRightPos += parseInt($("#divSepDiv").css("width").replace("px", ""));
        }

        // If the right copy magic slide out is shown, add the width of the slide out.
        if ($("#divCopyMagicContainer").css("display") != "none" && g_oSVGCopyMagic.g_bCopyMagicSlideoutShown) {
            iTargetRightPos += parseInt($("#divCopyMagicContainer").css("width").replace("px", ""));
        }

        // If we are in text compare mode, we need to add the width of the slider button if this is in the correct state.
        if ((g_oTextCompare.g_bTextCompareInProgress && bDisplayTop && g_oTextCompare.g_bTextCompareDivShown) || (g_oTextCompare.g_bTextCompareInProgress && !bDisplayTop && !g_oTextCompare.g_bTextCompareDivShown)) {
            iTargetRightPos += parseInt($("#divTextCompareButton").css("width").replace("px", ""));
        }

        // Show the bubble.
        $("#divGLSpeech" + g_iActiveBubbleId).toggle(true);

        // Determine animation to move in from the right.
        var iAnimateRight = (parseInt($("#divGLSpeech" + g_iActiveBubbleId).css('right')) == iTargetRightPos) ? iRightPos : iTargetRightPos;

        // Move any existing bubbles up to make room for the new bubble.
        for (var i = 0; i < g_oActiveBubbles.length; i++) {

            // If this bubble is in the same position as the bubble added.
            if (g_oActiveBubbles[i].displayTop == bDisplayTop) {

                // If the bubble is at the top of the window.
                if (bDisplayTop) {

                    // Move the bubble down by the new bubble height plus 10 pixels of margin.
                    $("#divGLSpeech" + g_oActiveBubbles[i].id).css("top", parseInt($("#divGLSpeech" + g_oActiveBubbles[i].id).css("top").replace("px", "")) + (iBubbleHeight + 10));
                }
                // If the bubble is at the bottom of the window.
                else {

                    // Move the bubble up by the new bubble height plus 10 pixels of margin.
                    $("#divGLSpeech" + g_oActiveBubbles[i].id).css("top", parseInt($("#divGLSpeech" + g_oActiveBubbles[i].id).css("top").replace("px", "")) - (iBubbleHeight + 10));
                }
            }
        }

        // Animate the bubble in from the right.
        $("#divGLSpeech" + g_iActiveBubbleId).animate({
            right: iAnimateRight + 'px'
        });

        // Add the bubble to the list of active bubbles.
        g_oActiveBubbles.push(new ActiveBubble(g_iActiveBubbleId, szType, bDisplayTop, bAutoClose));

        // Try to close the bubble if required.
        if (bAutoClose) {
            g_oGreenlightMessages.closeBubble(g_iActiveBubbleId, false, false);
        }

        // Increase the active bubble id.
        g_iActiveBubbleId++;
    }

    /**
     * Closes the speech bubble when required.
     * @param {int} iId - The id of the bubble to close.
     * @param {bool} bForceClose - If the bubble should be closed regardless of duration.
     * @param {bool} bAnimateOut - If the bubble should be animated out.
     */
    GreenlightMessage.prototype.closeBubble = function (iId, bForceClose, bAnimateOut) {
        // Locate the bubble from the list.
        var oBubble = $.grep(g_oActiveBubbles, function (bubble) { return bubble.id == iId; })[0];

        // Get the current date time.
        var dtNow = new Date();

        // If the bubble has been found.
        if (oBubble) {

            // Check if the bubble has been static for the configured seconds, or if we are forcing the close.
            if ((((dtNow - oBubble.displayDate) / 1000) > g_iBubbleCloseSeconds) || bForceClose) {

                // If we are animating the bubble out.
                if (bAnimateOut) {

                    // Animate and remove the bubble.
                    $("#divGLSpeech" + oBubble.id).animate({ right: $("#divGLSpeech" + oBubble.id).width() * -1 }, 400, function () { $("#divGLSpeech" + oBubble.id).remove(); });
                }
                // If we are not animating out.
                else {

                    // Hide and remove the bubble.
                    $("#divGLSpeech" + oBubble.id).fadeOut(400, function () { $("#divGLSpeech" + oBubble.id).remove(); });
                }

                // Remove the bubble from the list.
                g_oActiveBubbles = $.grep(g_oActiveBubbles, function (bubble) { return bubble.id != iId; });
            }
            // If the bubble has not been static for 5 seconds.
            else {

                // Check again in 1 second.
                setTimeout(function () { g_oGreenlightMessages.closeBubble(iId, bForceClose, bAnimateOut); }, 1000);
            }
        }
    }

    /**
     * Closes all active bubbles of a given type.
     * @param {string} type - The type of bubble to close.
     */
    GreenlightMessage.prototype.closeBubbles = function (type) {

        // Loop through each of the active bubbles.
        for (var i = 0; i < g_oActiveBubbles.length; i++) {

            // If this is a bubble of our desired type.
            if (g_oActiveBubbles[i].type == type || !type) {

                // Force close the bubble.
                g_oGreenlightMessages.closeBubble(g_oActiveBubbles[i].id, true, true);
            }
        }
    }

    /**
     * Toggles the bubble collapse.
     * @param {int} iId - The id of the bubble to toggle.
     */
    GreenlightMessage.prototype.toggleBubbleCollapse = function (iId) {

        // If the bubble is currently collapsed.
        if ($("#spanSpeech_Content_" + iId).css("display") == "none") {

            // Expand the bubble.
            $("#divGLSpeech" + iId).animate({ width: '300px' }, function () {

                // Show the span content.
                $("#spanSpeech_Content_" + iId).css("display", "block");
            });

            // Turn the icon.
            $("#divGLSpeech_Collapse_" + iId).css("transform", "rotate(0deg)");
        }
        // If the bubble is currently expanded.
        else {

            // Hide the span content.
            $("#spanSpeech_Content_" + iId).css("display", "none");

            // Collapse the bubble.
            $("#divGLSpeech" + iId).animate({ width: '50px' });

            // Turn the icon.
            $("#divGLSpeech_Collapse_" + iId).css("transform", "rotate(180deg)");
        }
    }

    // Apply to the window.
    window.GreenlightMessage = GreenlightMessage;
}());

